export default {"src":"/_next/static/media/fb-logo.acb7240a.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};